export default "__VITE_ASSET__BEZt0y4o__"